import { Position } from '@xyflow/react';
import { ERFElement } from '../../../enums';
import { L_FLOW_HEX, M_FLOW_HEX } from '../../../constants';
const TARGET_FLOW = {
    id: 'target_material_flow',
    type: 'target',
    name: 'Сырьё',
    position: Position.Left,
    style: { top: 72, left: 8, background: M_FLOW_HEX },
    connectionCount: 1
};
const TARGET_HYDROGEN_FLOW = {
    id: 'target_material_hydrogen_flow',
    type: 'target',
    name: 'Свежий ВСГ',
    position: Position.Left,
    style: { top: 52, left: 8, background: M_FLOW_HEX },
    connectionCount: 1
};
const TARGET_CYCLING_HYDROGEN_FLOW = {
    id: 'target_material_cycling_hydrogen_flow',
    type: 'target',
    name: 'Циркулирующий ВСГ',
    position: Position.Left,
    style: { top: 32, left: 8, background: M_FLOW_HEX },
    connectionCount: 1
};
const SOURCE_HYDROGEN_FLOW = {
    id: 'source_material_hydrogen_flow',
    type: 'source',
    name: 'Сдувка ВСГ',
    position: Position.Right,
    style: { top: 28, right: 8, background: M_FLOW_HEX },
    connectionCount: 1
};
const SOURCE_GAS_FLOW = {
    id: 'source_material_gas_flow',
    type: 'source',
    name: 'ВСГ',
    position: Position.Right,
    style: { top: 43, right: 8, background: M_FLOW_HEX },
    connectionCount: 1
};
const SOURCE_LIQUID_FLOW = {
    id: 'source_material_liquid_flow',
    type: 'source',
    name: 'Углеводороды',
    position: Position.Right,
    style: { top: 58, right: 8, background: M_FLOW_HEX },
    connectionCount: 1
};
const SOURCE_H2S_FLOW = {
    id: 'source_material_h2s_flow',
    type: 'source',
    name: '$H_2S',
    position: Position.Right,
    style: { top: 73, right: 8, background: M_FLOW_HEX },
    connectionCount: 1
};
const SOURCE_TOP_PRODUCT_FLOW = {
    id: 'source_material_top_product',
    type: 'source',
    name: 'Газ сероводородный',
    position: Position.Right,
    style: { top: 88, right: 8, background: M_FLOW_HEX },
    connectionCount: 1
};
const SOURCE_FRAC_1_FLOW = {
    id: 'source_material_frac_1',
    type: 'source',
    name: 'Сухой газ',
    position: Position.Right,
    style: { top: 103, right: 8, background: M_FLOW_HEX },
    connectionCount: 1
};
const SOURCE_FRAC_2_FLOW = {
    id: 'source_material_frac_2',
    type: 'source',
    name: 'Бензиновая фракция',
    position: Position.Right,
    style: { top: 118, right: 8, background: M_FLOW_HEX },
    connectionCount: 1
};
const SOURCE_BOTTOM_PRODUCT_FLOW = {
    id: 'source_material_bottom_product',
    type: 'source',
    name: 'Стабильный гидрогенизат',
    position: Position.Right,
    style: { top: 133, right: 8, background: M_FLOW_HEX },
    connectionCount: 1
};
const TARGET_LOGICAL = {
    id: 'target_logical_flow',
    type: 'target',
    name: 'Входные параметры',
    position: Position.Left,
    style: { top: 175, left: 9, background: L_FLOW_HEX },
    connectionCount: Number.MAX_SAFE_INTEGER
};
const SOURCE_LOGICAL = {
    id: 'source_logical_flow',
    type: 'source',
    name: 'Выходные параметры',
    position: Position.Right,
    style: { top: 175, right: 9, background: L_FLOW_HEX },
    connectionCount: Number.MAX_SAFE_INTEGER
};
export const DIESEL_HYDROTREATING_CONFIG = {
    type: ERFElement.DieselFuelHydrotreating,
    icon: 'DieselFuelHydrotreating_2d',
    templates: [
        {
            code: 'universal-template_mixer_reactorblock_separator',
            ports: [
                TARGET_FLOW,
                TARGET_CYCLING_HYDROGEN_FLOW,
                TARGET_HYDROGEN_FLOW,
                SOURCE_GAS_FLOW,
                SOURCE_LIQUID_FLOW,
                /* PORTS FOR LOGICAL ELEMENTS */
                TARGET_LOGICAL,
                SOURCE_LOGICAL
            ]
        },
        {
            code: 'universal-template_mixer_reactorblock_separator_fractionator',
            ports: [
                TARGET_FLOW,
                TARGET_CYCLING_HYDROGEN_FLOW,
                TARGET_HYDROGEN_FLOW,
                SOURCE_GAS_FLOW,
                SOURCE_TOP_PRODUCT_FLOW,
                SOURCE_FRAC_1_FLOW,
                SOURCE_FRAC_2_FLOW,
                SOURCE_BOTTOM_PRODUCT_FLOW,
                /* PORTS FOR LOGICAL ELEMENTS */
                TARGET_LOGICAL,
                SOURCE_LOGICAL
            ]
        },
        {
            code: 'universal-template_reactorblock_separator_compressor',
            ports: [
                TARGET_FLOW,
                TARGET_HYDROGEN_FLOW,
                SOURCE_HYDROGEN_FLOW,
                SOURCE_LIQUID_FLOW,
                /* PORTS FOR LOGICAL ELEMENTS */
                TARGET_LOGICAL,
                SOURCE_LOGICAL
            ]
        },
        {
            code: 'universal-template_reactorblock_separator_componentsplitter_compressor',
            ports: [
                TARGET_FLOW,
                TARGET_HYDROGEN_FLOW,
                SOURCE_HYDROGEN_FLOW,
                SOURCE_H2S_FLOW,
                SOURCE_LIQUID_FLOW,
                /* PORTS FOR LOGICAL ELEMENTS */
                TARGET_LOGICAL,
                SOURCE_LOGICAL
            ]
        },
        {
            code: 'universal-template_reactorblock_separator_compressor_fractionator',
            ports: [
                TARGET_FLOW,
                TARGET_HYDROGEN_FLOW,
                SOURCE_HYDROGEN_FLOW,
                SOURCE_TOP_PRODUCT_FLOW,
                SOURCE_FRAC_1_FLOW,
                SOURCE_FRAC_2_FLOW,
                SOURCE_BOTTOM_PRODUCT_FLOW,
                /* PORTS FOR LOGICAL ELEMENTS */
                TARGET_LOGICAL,
                SOURCE_LOGICAL
            ]
        },
        {
            code: 'universal-template_reactorblock_separator_componentsplitter_compressor_fractionator',
            ports: [
                TARGET_FLOW,
                TARGET_HYDROGEN_FLOW,
                SOURCE_HYDROGEN_FLOW,
                SOURCE_H2S_FLOW,
                SOURCE_TOP_PRODUCT_FLOW,
                SOURCE_FRAC_1_FLOW,
                SOURCE_FRAC_2_FLOW,
                SOURCE_BOTTOM_PRODUCT_FLOW,
                /* PORTS FOR LOGICAL ELEMENTS */
                TARGET_LOGICAL,
                SOURCE_LOGICAL
            ]
        }
    ]
};
//# sourceMappingURL=RFDieselFuelHydrotreatingNode.config.js.map